
import React from "react";
import { getStatusColor, getStatusLabel, StatusType } from "@/data/mockData";
import { cn } from "@/lib/utils";

interface StatusBadgeProps {
  status: StatusType;
  className?: string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, className }) => {
  const colorClass = getStatusColor(status);
  const label = getStatusLabel(status);
  
  return (
    <div 
      className={cn(
        "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium transition-all",
        `bg-${colorClass}/10 text-${colorClass}`,
        "animate-enter-right",
        className
      )}
    >
      <div className={cn("w-1.5 h-1.5 rounded-full mr-1.5", `bg-${colorClass}`)} />
      {label}
    </div>
  );
};

export default StatusBadge;
